import actionTypes from "../actions/actionTypes";

const initialState = {
  myDrafts: null,
  myDraftsCount: null,
  publishedByMe: null,
  publishedByMeCount: null,
  publishedByOthers: null,
  publishedByOthersCount: null,
  transcriptionDetails: null,
  transcriptionDetailsCount: null,
  getClassDetailsById: null,
  deleteShotclassLoader: false,

  getTrainingTypesLoader: false,
  getLanguagesLoader: false,
  isShotclassNameExistLoader: false,
  getShotclassTagLoader: false,
  saveAsADraftLoader: false,
  getUserGroupsLoader: false,
  shotclassPublishLoader: false,
  getYoutubeVideosLoader: false,
  getOnlineCoursesLoader: false,
  getSlidesharesLoader: false,

  addTrainingTypeLoader: false,
  deleteTrainingTypeLoader: false,

  addCSVBulkUploadLoader: false,
  deleteQuizImagesLoader: false,
  uploadQuizImagesLoader: false,

  getTranscriptionDataLoader: false,
  addTranscribeTagLoader: false,

  videoUploadList: [],
  showVideoUploadListPanel: false,
};

const manageReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.manageTypes.GET_MY_DRAFTS:
      return { ...state, myDrafts: payload, myDraftsCount: action.count };
    case actionTypes.manageTypes.GET_PUBLISHED_BY_ME:
      return {
        ...state,
        publishedByMe: payload,
        publishedByMeCount: action.count,
      };
    case actionTypes.manageTypes.RESET_MY_DRAFTS_COUNT:
      return {
        ...state,
        myDraftsCount: null,
      };
    case actionTypes.manageTypes.GET_PUBLISHED_BY_OTHERS:
      return {
        ...state,
        publishedByOthers: payload,
        publishedByOthersCount: action.count,
      };
    case actionTypes.manageTypes.GET_TRANSCRIPTION_DETAILS:
      return {
        ...state,
        transcriptionDetails: payload,
        transcriptionDetailsCount: action.count,
      };
    case actionTypes.manageTypes.DELETE_SHOTCLASS_LOADER:
      return {
        ...state,
        deleteShotclassLoader: payload,
      };

    case actionTypes.manageTypes.GET_CLASS_DETAILS_BY_ID:
      return {
        ...state,
        getClassDetailsById: payload,
      };
    case actionTypes.manageTypes.SET_GET_LANGUAGES_LOADER:
      return {
        ...state,
        getLanguagesLoader: payload,
      };
    case actionTypes.manageTypes.SET_IS_SHOTCLASS_NAME_EXIST_LOADER:
      return {
        ...state,
        isShotclassNameExistLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_YOUTUBE_VIDEOS_LOADER:
      return {
        ...state,
        getYoutubeVideosLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_ONLINE_COURSES_LOADER:
      return {
        ...state,
        getOnlineCoursesLoader: payload,
      };
    case actionTypes.manageTypes.SET_SAVE_AS_A_DRAFT_LOADER:
      return {
        ...state,
        saveAsADraftLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_USER_GROUPS_LOADER:
      return {
        ...state,
        getUserGroupsLoader: payload,
      };
    case actionTypes.manageTypes.SET_SHOTCLASS_PUBLISH_LOADER:
      return {
        ...state,
        shotclassPublishLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_SLIDESHARES_LOADER:
      return {
        ...state,
        getSlidesharesLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_TRAININGS_LOADER:
      return {
        ...state,
        getTrainingTypesLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_SHOTCLASS_TAG_LOADER:
      return {
        ...state,
        getShotclassTagLoader: payload,
      };
    case actionTypes.manageTypes.SET_ADD_TRAINING_LOADER:
      return {
        ...state,
        addTrainingTypeLoader: payload,
      };
    case actionTypes.manageTypes.SET_DELETE_TRAINING_LOADER:
      return {
        ...state,
        deleteTrainingTypeLoader: payload,
      };
    case actionTypes.manageTypes.SET_BULK_UPLOAD_CSV_LOADER:
      return {
        ...state,
        addCSVBulkUploadLoader: payload,
      };
    case actionTypes.manageTypes.SET_DELETE_QUIZ_IMAGES_LOADER:
      return {
        ...state,
        deleteQuizImagesLoader: payload,
      };
    case actionTypes.manageTypes.SET_UPLOAD_QUIZ_IMAGES_LOADER:
      return {
        ...state,
        uploadQuizImagesLoader: payload,
      };
    case actionTypes.manageTypes.SET_GET_TRANSCRIPTION_DATA_LOADER:
      return {
        ...state,
        getTranscriptionDataLoader: payload,
      };
    case actionTypes.manageTypes.SET_ADD_TRANSCRIBE_TAG_LOADER:
      return {
        ...state,
        addTranscribeTagLoader: payload,
      };

    case actionTypes.manageTypes.SET_UPDATE_VIDEO_LIST:
      return {
        ...state,
        videoUploadList: payload,
      };
    case actionTypes.manageTypes.SET_SHOW_VIDEO_UPLOAD_LIST_PANEL:
      return {
        ...state,
        showVideoUploadListPanel: payload,
      };
    default:
      return state;
  }
};

export default manageReducer;
